import React from "react";
import { Field, useForm, useFormState } from "react-final-form";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import Button from "../../../../../components/Button";
import Autocomplete from "../../../../../components/Autocomplete";
import useMajorQueries from "../../../../major/hooks/useMajorQueries";
import { useQuery } from "react-query";
import { QUERY_KEYS } from "../../../../../constants";
import { WizardMode } from "../../../../wizard/types";
import { useWizard } from "../../../../wizard/context";
import { useAddMajorConfig } from "../../hooks/useAddMajorConfig";

const useStyles = makeStyles((theme) => ({
  majorSection: {
    marginBottom: 16,
  },
  title: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#535358",
    lineHeight: 1,
    marginTop: 16,
    marginBottom: 16,
  },
  addNewButton: {
    fontSize: 17,
    fontWeight: "bold",
    height: 44,
    color: "#fefefe",
    backgroundColor: "#7ec884",
    width: 156,
    marginTop: 18,
    paddingLeft: "32px !important",
    paddingRight: "32px !important",
  },
}));

const MajorSection = ({ name }) => {
  const classes = useStyles();
  const formData: any = useFormState();
  const { change } = useForm();
  const isCreateMode = formData.values.mode === WizardMode.Create;

  const { majors: majorsQueryKey } = QUERY_KEYS;
  const { fetchAll: fetchAllMajors } = useMajorQueries();
  const { data: majors } = useQuery<any>(majorsQueryKey, fetchAllMajors);
  const { openWizard } = useWizard();
  const addMajorModalConfig = useAddMajorConfig();

  const addMajorHandler = async () => {
    const result = await openWizard(addMajorModalConfig);
    if (!result) {
      return;
    }

    change(`${name}.major`, result);
  };

  return (
    <div className={classes.majorSection}>
      <Typography className={classes.title}>Major</Typography>
      <Grid container spacing={2}>
        {!isCreateMode && (
          <Grid item xs={12} sm={12} md={12}>
            <Typography>{formData.values[name].major.name}</Typography>
          </Grid>
        )}
        {isCreateMode && (
          <>
            <Grid item xs={12} sm={12} md={9}>
              <Field
                required
                fullWidth
                label="Major"
                options={majors?.data}
                placeholder="Please Select"
                name={`${name}.major`}
                component={Autocomplete}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3}>
              <Button
                color={"success"}
                fullWidth
                onClick={addMajorHandler}
                variant="contained"
                className={classes.addNewButton}
              >
                Add Major
              </Button>
            </Grid>
          </>
        )}
      </Grid>
    </div>
  );
};

export default MajorSection;
